export default {
  landing: {
    features: "功能特点",
    solutions: "解决方案",
    pricing: "定价",
    waitlist: "申请早期访问",
    faq: "常见问题",
    contact: "联系我们",
    about: "关于",
    tools: "免费工具",
  },
  upload: "上传",
  history: "历史记录",
  home: "首页",
  userMenu: {
    login: "登录",
    dashboard: "控制面板",
    history: "历史记录",
    logout: "退出登录",
    themeMode: "主题",
    themeLight: "浅色",
    themeDark: "深色",
    themeSystem: "系统",
  },
};
